/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AnswerPollInput } from '../models/AnswerPollInput';
import type { PollDetailDto } from '../models/PollDetailDto';
import type { UserPollDto } from '../models/UserPollDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PollService {

    /**
     * @param version 
     * @returns UserPollDto OK
     * @throws ApiError
     */
    public static getPolls(
version: string,
): CancelablePromise<Array<UserPollDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Poll',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param hashId 
     * @param version 
     * @returns PollDetailDto OK
     * @throws ApiError
     */
    public static getPollDetail(
hashId: string,
version: string,
): CancelablePromise<PollDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/Poll/{hashId}',
            path: {
                'hashId': hashId,
                'version': version,
            },
        });
    }

    /**
     * @param hashId 
     * @param version 
     * @param requestBody 
     * @returns PollDetailDto OK
     * @throws ApiError
     */
    public static answerPoll(
hashId: string,
version: string,
requestBody?: AnswerPollInput,
): CancelablePromise<PollDetailDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/Poll/{hashId}/Answer',
            path: {
                'hashId': hashId,
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

}
